import { action, runInAction, extendObservable, toJS } from "mobx";

export class StaffStore {
    resourceStore = null;
    allPlayers = [];
    teamId = null;

    constructor() {
        extendObservable(this, {
            allPlayers: [],
            teamId: null,
            setInitialData: action(this.setInitialData),
            setRole: action(this.setRole),
            removeStaff: action(this.removeStaff),
            syncSelection: action(this.syncSelection),
        });
    }

    async setInitialData(data, teamId, resourceStore) {
        this.allPlayers = data || [];
        this.teamId = teamId;
        this.resourceStore = resourceStore;
    }

    syncSelection(selectedIds, teamId, items) {
        let players = Object.values(toJS(this.allPlayers));

        const itemsArray = toJS(items);

        const existingTeamPlayers = players.filter((p) => p.dhbTeam === teamId);

        const removedIds = existingTeamPlayers
            .filter((p) => !selectedIds.includes(p.contact))
            .map((p) => p.contact);

        const playersToAdd = [];

        selectedIds.forEach((contact) => {
            const existing = existingTeamPlayers.find(
                (p) => p.contact === contact,
            );

            if (existing) {
                delete existing.isDeleted;
                delete existing.isChanged;
            } else {
                const item = itemsArray.find((i) => i.id === contact);

                if (!item) return;

                playersToAdd.push({
                    contact,
                    dhbTeam: teamId,
                    notSaved: true,
                    isChanged: true,
                    contactName: `${item.firstName} ${item.lastName}`,
                });
            }
        });

        players.forEach((p) => {
            if (p.dhbTeam === teamId && removedIds.includes(p.contact)) {
                p.isDeleted = true;
                p.matchRole = 0;
                p.isChanged = true;
            }
        });

        players = [
            ...players.filter(
                (p) => !playersToAdd.some((a) => a.contact === p.contact),
            ),
            ...playersToAdd,
        ];

        players = players.filter((p) => {
            if (p.notSaved && p.isDeleted) return false;
            return true;
        });

        const next = {};
        players.forEach((p) => {
            next[p.contact] = p;
        });

        this.allPlayers = next;

        this.sync();
    }

    setRole(staffId, roleId) {
        this.allPlayers[staffId] = {
            ...this.allPlayers[staffId],
            matchRole: roleId,
            isChanged: true,
        };

        this.sync();
    }

    removeStaff(staffId) {
        const staff = this.allPlayers[staffId];
        if (!staff) return;

        if (staff.notSaved) {
            const next = { ...this.allPlayers };
            delete next[staffId];
            this.allPlayers = next;

            this.sync();
            return;
        }

        const updatedStaff = {
            ...staff,
            isDeleted: true,
            matchRole: 0,
            isChanged: true,
        };

        this.allPlayers[staffId] = updatedStaff;

        this.sync();
    }

    sync() {
        if (!this.resourceStore) return;

        runInAction(() => {
            this.resourceStore.change("allMatchStaff", this.allPlayers);
            this.resourceStore.change("isStaffChange", true);
        });
    }

    removeDataChange() {
        if (!this.resourceStore) return;

        runInAction(() => {
            delete this.resourceStore.data.isStaffChange;
        });
    }

    removeNotSavedPlayers() {
        const filteredEntries = Object.entries(this.allPlayers).filter(
            ([_, staff]) => !staff.notSaved,
        );

        this.allPlayers = Object.fromEntries(filteredEntries);

        runInAction(() => {
            this.resourceStore.change("allMatchStaff", this.allPlayers);
        });
    }
}

export const staffStore = new StaffStore();
